export const t_global_breakpoint_height_lg = {
  "name": "--pf-t--global--breakpoint--height--lg",
  "value": "48rem",
  "var": "var(--pf-t--global--breakpoint--height--lg)"
};
export default t_global_breakpoint_height_lg;